import React, { Fragment, useContext } from 'react';
import sneak from '../images/sneak.png';
import Navbar from 'react-bootstrap/Navbar';
import { Nav, Badge, Container } from 'react-bootstrap';
import { Link, NavLink, useHistory } from 'react-router-dom';
import UserContext from '../UserContext';
import { useGlobalContext } from '../context';

export default function NavBar() {
  const history = useHistory();
  const { user, setUser, unsetUser } = useContext(UserContext);
  console.log(user);
  const { qty } = useGlobalContext();

  const logout = () => {
    unsetUser();
    setUser({ accessToken: null });
    history.push('/login');
  };

  let rightNav =
    user.accessToken !== null ? (
      user.isAdmin ? (
        <Fragment>
          <Nav.Link className='navi-link' as={NavLink} to='/add-product'>
            Add Product
          </Nav.Link>
          <Nav.Link className='navi-link' onClick={logout}>
            Logout
          </Nav.Link>
        </Fragment>
      ) : (
        <Fragment>
          <Nav.Link className='navi-link' as={NavLink} to='/cart'>
            Cart <Badge bg='secondary'>{qty}</Badge>
          </Nav.Link>
          <Nav.Link className='navi-link' onClick={logout}>
            Logout
          </Nav.Link>
        </Fragment>
      )
    ) : (
      <Fragment>
        <Nav.Link className='navi-link' as={NavLink} to='/login'>
          Login
        </Nav.Link>
        <Nav.Link className='navi-link' as={NavLink} to='/register'>
          Register
        </Nav.Link>
      </Fragment>
    );

  return (
    <Container>
      <Navbar className='navi' expand='lg'>
        <Navbar.Toggle aria-controls='basic-navbar-nav' variant='primary' />
        <Navbar.Collapse id='basic-navbar-nav'>
          <Nav className='mr-auto'>
            <Nav.Link className='navi-link' as={NavLink} to='/'>
              Home
            </Nav.Link>
            <Nav.Link className='navi-link' as={NavLink} to='/shop'>
              Shop
            </Nav.Link>
          </Nav>
          <Navbar.Brand href='/' className='navi-header'>
            <img alt='' src={sneak} width='200' height='60' />{' '}
          </Navbar.Brand>
          <Nav className='ml-auto'>{rightNav}</Nav>
        </Navbar.Collapse>
      </Navbar>
    </Container>
  );
}
